import { render, staticRenderFns } from "./ProductOptionRunkan.vue?vue&type=template&id=287ab14c&scoped=true&"
import script from "./ProductOptionRunkan.vue?vue&type=script&lang=js&"
export * from "./ProductOptionRunkan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287ab14c",
  null
  
)

export default component.exports